import { render } from "./NewsOverview.vue?vue&type=template&id=80ec605c&scoped=true"
import script from "./NewsOverview.vue?vue&type=script&lang=js"
export * from "./NewsOverview.vue?vue&type=script&lang=js"

import "./NewsOverview.vue?vue&type=style&index=0&id=80ec605c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80ec605c"]])

export default __exports__